var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m10.18 8 5.593 5.639a.6.6 0 0 1 .227.5.6.6 0 0 1-.227.499l-1.135 1.135a.6.6 0 0 1-.5.227.6.6 0 0 1-.5-.227L8 10.18l-5.639 5.593a.6.6 0 0 1-.5.227.6.6 0 0 1-.499-.227L.227 14.638a.6.6 0 0 1-.227-.5q0-.317.227-.5L5.82 8 .227 2.361a.6.6 0 0 1-.227-.5q0-.317.227-.499L1.362.227a.6.6 0 0 1 .5-.227q.317 0 .5.227L8 5.82 13.639.227a.6.6 0 0 1 .5-.227q.317 0 .499.227l1.135 1.135a.6.6 0 0 1 .227.5.6.6 0 0 1-.227.5z"
  })));
};
export default SvgCross;